import React, { useEffect } from 'react';
import real_l from "../real_logo.png";



function Print({ tableHTML, title, onComplete }) {
  useEffect(() => {
    const printWindow = window.open("", "", "height=600,width=800");
    const img = document.createElement('img');
    img.src = real_l;
    var User = JSON.parse(window.localStorage.getItem("Name"));

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString();
    const formattedTime = currentDate.toLocaleTimeString();

    printWindow.document.write(`
      <html>
        <head>
          <title>Print View</title>
          <style>
            h1 {
              display: inline-block;
              vertical-align: middle;
              margin: 0;
              margin-top:2%;
              text-align: center;
              width: 100%;
              font-family: Arial, sans-serif;
            }

            img {
              display: inline-block;
              height: 50px;
              margin-right: 10px;
            }

            table {
              border: 1px solid black;
              border-collapse: collapse;
              width: 100%;
              font-family: Arial, sans-serif;
            }

            th, td {
              border: 1px solid black;
              padding: 5px;
            }

            tr:nth-child(even) {
              background-color: #f2f2f2;
            }

            .bottom-right {
              position:relative;
              bottom: 10px;
              right: 10px;
              font-family: Arial, sans-serif;
            }
          </style>
        </head>
        <body>
          <h1>${img.outerHTML} </h1>
     
          <h1>${title} </h1>
          <table>${tableHTML}</table>
          <p class="bottom-right">Printed By: ${User}</p>
          <p class="bottom-right">Date Created: ${formattedDate} ${formattedTime}</p>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
      if (onComplete) onComplete();
    }, 500);
  }, [tableHTML, onComplete]);



  return null; // no UI
}

export default Print;
